// extracted by mini-css-extract-plugin
module.exports = {"container":"ThemeSwitcher_container__1WSGu","switch":"ThemeSwitcher_switch__369-W","slider":"ThemeSwitcher_slider__3dBN4","round":"ThemeSwitcher_round__1Dia5"};